// RMFN — AJAX Add-to-Cart with live Header (desktop+mobile) + Drawer refresh (Stereo)
// + Sold-out title guard (keeps titles visible even with hover overlays)
(function () {
 // --- init listeners ---
 document.addEventListener('click', onAjaxAdd);
 document.addEventListener('DOMContentLoaded', () => {
   ensureSoldOutCSS();
   fixSoldOutTitles();
 });
 // If theme dynamically loads sections, re-apply
 window.addEventListener('shopify:section:load', (e) => {
   ensureSoldOutCSS();
   fixSoldOutTitles(e.target || document);
 });
 async function onAjaxAdd(e) {
   const btn = e.target.closest('form[data-ajax-add] button[type="submit"]');
   if (!btn) return;
   e.preventDefault();
   e.stopPropagation();
   const form = btn.closest('form[data-ajax-add]');
   if (!form) return;
   const originalText = btn.textContent;
   btn.disabled = true;
   btn.textContent = 'Adding…';
   try {
     // 1) Add silently
     const body = new URLSearchParams(new FormData(form)).toString();
     const addRes = await fetch('/cart/add.js', {
       method: 'POST',
       headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' },
       body
     });
     if (!addRes.ok) {
       const err = await addRes.json().catch(() => ({}));
       throw new Error(err.description || 'Could not add to cart.');
     }
     // 2) Pull updated cart
     const cart = await (await fetch('/cart.js')).json();
     // 3) Update ALL visible counters (desktop + mobile)
     updateHeaderCartCount(cart.item_count);
     // 4) Re-render ALL header sections (desktop/mobile headers)
     await refreshAllHeaderSections();
     // 5) Refresh drawer section so it shows new items immediately
     await refreshDrawerSection();
     // 6) Open drawer if a non-link toggle exists (no redirects)
     openCartDrawerSafely();
     // 7) Broadcast for any theme listeners
     window.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));
     // 8) Safety: re-apply sold-out title guard after DOM changes
     ensureSoldOutCSS();
     fixSoldOutTitles();
     showToast('Added to cart');
   } catch (err) {
     showToast(err.message || 'Add to cart failed', true);
   } finally {
     btn.textContent = originalText;
     btn.disabled = false;
   }
 }
 // ---- Helpers ----
 // Update visible cart counts across desktop AND mobile
 function updateHeaderCartCount(count) {
   const selectors = [
     '#cart-icon-bubble',
     '[id^="cart-icon-bubble"]',
     '[data-cart-count]',
     '[data-cart-items-count]',
     '.cart-count-bubble',
     '.header__cart-count',
     '.site-header__cart-count',
     '.cart-count',
     '.cart__count',
     '.header-cart__count',
     '.cart-link__count',
     '.count-bubble',
     '.mini-cart-count'
   ];
   document.querySelectorAll(selectors.join(',')).forEach(el => {
     const txt = el.textContent.trim();
     if (/^\(\s*\d+\s*\)$/.test(txt)) {
       el.textContent = `(${count})`;
     } else {
       el.textContent = String(count);
     }
     el.classList.remove('hidden', 'visually-hidden');
     el.setAttribute('aria-hidden', 'true');
   });
   // Update nearby ARIA text like "0 items" → "N items"
   document
     .querySelectorAll('.cart-open-trigger .visually-hidden, .header__cart .visually-hidden')
     .forEach(el => {
       el.textContent = `${count} item${count === 1 ? '' : 's'}`;
     });
 }
 // Re-render ALL header sections (covers separate mobile/desktop header wrappers)
 async function refreshAllHeaderSections() {
   const headers = Array.from(document.querySelectorAll('[id^="shopify-section-"][id*="header"]'));
   if (!headers.length) return;
   const url = window.location.pathname + window.location.search;
   const sep = url.includes('?') ? '&' : '?';
   await Promise.all(
     headers.map(async (headerEl) => {
       const sectionId = headerEl.id.replace(/^shopify-section-/, '');
       try {
         const res = await fetch(`${url}${sep}section_id=${encodeURIComponent(sectionId)}`, {
           credentials: 'same-origin'
         });
         const html = await res.text();
         const tmp = document.createElement('div');
         tmp.innerHTML = html.trim();
         const fresh = tmp.querySelector('#' + CSS.escape(headerEl.id));
         if (fresh) headerEl.replaceWith(fresh);
       } catch (_) {}
     })
   );
 }
 // Find and refresh the drawer section so it shows the new items
 async function refreshDrawerSection() {
   let drawer = document.querySelector('[id*="CartDrawer"], [class*="cart-drawer"], [aria-label*="Your cart"]');
   if (!drawer) {
     const cartLink = document.querySelector('a.cart-open-trigger, a[href="/cart"]');
     if (cartLink) drawer = cartLink.closest('[id^="shopify-section-"]');
   }
   const sectionEl = drawer ? drawer.closest('[id^="shopify-section-"]') : null;
   if (!sectionEl) return;
   const sectionId = sectionEl.id.replace(/^shopify-section-/, '');
   const url = window.location.pathname + window.location.search;
   const sep = url.includes('?') ? '&' : '?';
   try {
     const res = await fetch(`${url}${sep}section_id=${encodeURIComponent(sectionId)}`, {
       credentials: 'same-origin'
     });
     const html = await res.text();
     const tmp = document.createElement('div');
     tmp.innerHTML = html.trim();
     const fresh = tmp.querySelector('#' + CSS.escape(sectionEl.id));
     if (fresh) sectionEl.replaceWith(fresh);
   } catch (_) {}
 }
 // Try to open the drawer by clicking a non-link control (avoid redirect)
 function openCartDrawerSafely() {
   const toggle =
     document.querySelector('button[aria-controls*="CartDrawer"]') ||
     document.querySelector('[data-drawer-toggle]') ||
     document.querySelector('[data-open-cart]') ||
     document.querySelector('.header__icon--cart') ||
     document.querySelector('[aria-controls*="cart-drawer"]');
   if (toggle && toggle.tagName !== 'A' && typeof toggle.click === 'function') {
     toggle.click();
   }
 }
 // --- SOLD-OUT TITLE GUARD ---
 // Inject CSS once
 function ensureSoldOutCSS() {
   if (document.getElementById('rmfn-soldout-css')) return;
   const s = document.createElement('style');
s.id = 'rmfn-soldout-css';
   s.textContent = `
     /* Force titles to remain visible on sold-out cards (even with hover overlay) */
     .rmfn-sold-out .card__information {
       opacity: 1 !important;
       transform: none !important;
       visibility: visible !important;
       position: static !important;
     }
   `;
   document.head.appendChild(s);
 }
 // Add class to any card that's sold out so the CSS above applies
 function fixSoldOutTitles(root = document) {
   const cards = root.querySelectorAll('.card.card--product, .product-card, [data-product-card]');
   cards.forEach(card => {
     // Heuristics:
     // - If there is a disabled button that says "Sold out"
     // - Or there is no form[data-ajax-add] present (some themes omit the form for sold-out)
     const soldByButton =
       !!card.querySelector('button[disabled]') &&
       /sold\s*out/i.test(card.querySelector('button[disabled]')?.textContent || '');
     const noForm = !card.querySelector('form[data-ajax-add]');
     if (soldByButton || noForm) {
       card.classList.add('rmfn-sold-out');
     } else {
       card.classList.remove('rmfn-sold-out');
     }
   });
 }
 // Tiny toast
 function showToast(text, isError) {
   const el = document.createElement('div');
   el.className = 'rmfn-toast' + (isError ? ' rmfn-toast--error' : '');
   el.textContent = text;
   document.body.appendChild(el);
   setTimeout(() => el.classList.add('is-in'), 10);
   setTimeout(() => {
     el.classList.remove('is-in');
     setTimeout(() => el.remove(), 250);
   }, 1200);
 }
})();
